// extracted by css-extract-rspack-plugin
export default {"jumpToItem":"JumpToItem-module__jumpToItem__ctO6c","jumpToItemFocused":"JumpToItem-module__jumpToItemFocused__qwxm8","jumpToLink":"JumpToItem-module__jumpToLink__DK4xw"};